
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_9874_3522)","stroke":"#1C2F45","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M13.058 9.02v2.691a1.346 1.346 0 01-1.346 1.347H2.289A1.346 1.346 0 01.942 11.71V9.02M10.366 4.308L7 .942 3.635 4.308M7 .942V9.02"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_9874_3522"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h14v14H0z"}})])])])
          )
        }
      }
    